/* src/app/pages/paciente/pacientes-public/pacientes-public.component.scss */
/*# sourceMappingURL=pacientes-public.component.css.map */
